import { VerticalLine } from "../VerticalLine/VerticalLine";

type Props = {
    name?: string;
    sections: {
        name: string;
        elements: any[];
    }[];
};

export const ControlBar = (props: Props) => {
    // do we need a secondary map fo rthe vertical line add?

    const sectionsWithElements = props.sections.filter((section) => section.elements.length > 0);
    const countOfSectionsWithElements = sectionsWithElements.length;

    return (
        <div
            className={
                "ControlBar d-inline-flex justify-content-end align-items-center d-print-none mb-2 secondary-bg-color rounded-5 px-3 py-2"
            }>
            {sectionsWithElements.map((section, sectionIndex) => {
                const composed = section.elements
                    .filter((element) => !!element)
                    .map((element, elementIndex) => {
                        if (element) {
                            return (
                                <div
                                    key={`${section.name}-element-${elementIndex}`}
                                    className={elementIndex < section.elements.length - 1 ? "me-2" : ""}>
                                    {element}
                                </div>
                            );
                        } else {
                            return null;
                        }
                    });

                if (!composed.length) {
                    return null;
                }

                const addVerticalLine = sectionIndex < countOfSectionsWithElements - 1;

                // Return the section with a key
                return (
                    <div key={`section-${sectionIndex}`} className="d-flex justify-content-center align-items-center">
                        {composed}
                        {addVerticalLine ? <VerticalLine /> : null}
                    </div>
                );
            })}
        </div>
    );
};
